import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function Studentsignup() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setErrorMessages([]);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "auth/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        if (Array.isArray(data.message)) {
          setErrorMessages(data.message);
        } else {
          setErrorMessages([data.message || t("signup_error")]);
        }
        return;
      }

      setSuccessMessage(data.message);
      setTimeout(() => {
        navigate("/login");
      }, 4000);
    } catch (err) {
      setErrorMessages([t("signup_generic_error")]);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100 w-100">
      <Container>
        <Row className="justify-content-center w-100">
          <Col md={5} className="m-4 p-4">
            <h2 className="text-center mb-4">{t("signup")}</h2>

            {errorMessages.length > 0 && (
              <Alert variant="danger">{errorMessages[0]}</Alert>
            )}

            {successMessage && (
              <Alert variant="success" className="mt-3">
                {successMessage}
              </Alert>
            )}

            <Form onSubmit={handleSignup}>
              <Form.Group className="mb-3" controlId="first_name">
                <Form.Label>{t("first_name")}</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  placeholder={t("enter_first_name")}
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="last_name">
                <Form.Label>{t("last_name")}</Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  placeholder={t("enter_last_name")}
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>{t("email")}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder={t("enter_email")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="password">
                <Form.Label>{t("password")}</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder={t("enter_password")}
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button type="submit" variant="primary" className="w-100">
                {t("signup")}
              </Button>
            </Form>

            <div className="text-center mt-3">
              {t("already_have_account")} <Link to="/login">{t("login")}</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Studentsignup;
